export default __webpack_public_path__ + "static/media/program_intro_13.bbcfce9b.png";